/**
 * Instant splash control.
 *
 * The #instant-hello element in index.html is visible on every open before the
 * JS bundle loads (brand cyan, icon + spinner). React hides it when the first
 * real screen is ready: ScreenRouter for normal opens, App.handleAnonReady for
 * the exchange flow (which owns its instrumented hide moment — connectionTiming
 * measures spinner duration from window.__SPINNER_SHOWN_AT__).
 *
 * index.html also has an 8s failsafe that hides the splash if React never loads.
 */
export const hideInstantSplash = () => {
  const el = document.getElementById('instant-hello');
  if (!el) return;
  el.style.opacity = '0';
  setTimeout(() => el.remove(), 300); // match the CSS transition duration
};
